
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    categories: {
      type: Object,
    },
  },

  data() {
    return {
      activeImage: "image-gallery/image_not_found.svg",
      activeCategory: "",
    };
  },

  computed: {
    images(): Array<string> | undefined {
      if (this.categories) {
        const nested = Object.values(this.categories).map((category) => {
          return category["images"];
        });
        return nested.flat();
      } else {
        return undefined;
      }
    },
  },

  methods: {
    updateImage(): void {
      if (this.images) {
        let index = Math.floor(Math.random() * this.images.length);
        if (this.activeImage === this.images[index]) {
          if (index + 1 === this.images.length) {
            // When at the final item, loop back to first
            index = 0;
          } else {
            index += 1;
          }
        }

        this.activeImage = this.images[index];
        const category = this.activeImage.split("/")[1];
        this.activeCategory = // Make category uppercase
          category.charAt(0).toUpperCase() + category.slice(1);
      } // Else, don't update
    },
  },

  watch: {
    categories() {
      // Show a random image, when categories are finally fetched
      this.updateImage();
    },
  },
});
